import React from 'react';
import { Typography, Box, makeStyles } from '@material-ui/core';
// import Loader from '../../Loader';
import { useStyles } from '../style';
import { getPath } from '../../../utils/getPath';

const FutureDiscount = ({ discount, rentDays, loading, withBottomPadding }) => {
    const classes = useStyles();
    const localClasses = useLocalStyles();

    return (
        <>
            <Typography className={classes.heading}>Будущая скидка</Typography>
            {/* {loading && <Loader p={1} size={40} />} */}
            {/* {!loading && <Typography className={classes.value}>{discount || '-'}%</Typography>} */}

            <Typography className={classes.value}>
                <img src={getPath('public/img/gift.svg')} alt="" className={localClasses.giftIcon} />
            </Typography>

            {withBottomPadding && <Box mb={3} />}
        </>
    );
};

const useLocalStyles = makeStyles(theme => ({
    giftIcon: {
        width: 65,
        height: 65,
    },
}));

export default FutureDiscount;
